function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _excluded = ["columns", "header", "footer", "rowClassName", "rowOnClick", "rows", "style", "truncate", "allSelected", "onSelect", "onSelectAll", "rowSelected", "expandableColumn", "onExpand", "rowExpanded", "renderRow"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import classnames from 'classnames';
import uniqueId from 'lodash.uniqueid';
import PropTypes from 'prop-types';
import React from 'react';
import Button from "../Button/Button";
import Icon from "../Icon/Icon";
import Label from "../Label/Label";
import Header from "./components/Header";
import Table from "./Table";

function getAlignment(align) {
  /* eslint-disable no-console */
  switch (align) {
    case 'left':
      console.warn('SortableTable: align="left" is deprecated. Please use align="start" instead.');
      return 'start';

    case 'right':
      console.warn('SortableTable: align="right" is deprecated. Please use align="end" instead.');
      return 'end';

    default:
      return align;
  }
  /* eslint-enable no-console */

}

function generateColumnClassName(column) {
  var truncate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return classnames(truncate && 'text-truncate', column.align && "text-".concat(getAlignment(column.align)), column.className);
}

function defaultRenderRow(row, columns, rowClassName, rowExpanded, rowOnClick, truncate, rowSelected, isLastRow) {
  var expanded = rowExpanded(row);
  return [/*#__PURE__*/React.createElement("tr", {
    key: row.key,
    className: classnames({
      'table-primary': rowSelected && rowSelected(row)
    }, rowClassName(row)),
    onClick: function onClick(e) {
      return rowOnClick && rowOnClick(row, e);
    },
    role: rowOnClick ? 'button' : null
  }, columns.map(function (column) {
    return /*#__PURE__*/React.createElement("td", {
      key: column.key,
      className: generateColumnClassName(column, truncate)
    }, column.cell(row, expanded, isLastRow));
  })), expanded && /*#__PURE__*/React.createElement("tr", {
    key: row.key ? "".concat(row.key, "-hidden") : null,
    hidden: true
  }), expanded && /*#__PURE__*/React.createElement("tr", {
    key: row.key ? "".concat(row.key, "-expanded") : null,
    className: classnames({
      'table-primary': rowSelected && rowSelected(row)
    }, 'tr-expanded')
  }, /*#__PURE__*/React.createElement("td", {
    className: "border-top-0",
    colSpan: columns.length
  }, expanded))];
}

function getSelectableCell(row, rowSelected, onSelect) {
  var selectRowId = uniqueId('select-row-');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    for: selectRowId,
    hidden: true
  }, "Select row"), /*#__PURE__*/React.createElement("input", {
    id: selectRowId,
    type: "checkbox",
    className: "mx-1",
    checked: rowSelected(row),
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onChange: function onChange(e) {
      return onSelect(row, e.target.checked);
    }
  }));
}

function getExpandableCell(row, expanded, onExpand) {
  return /*#__PURE__*/React.createElement(Button, {
    className: "px-2 py-0",
    color: "link",
    onClick: function onClick() {
      return onExpand(row);
    },
    "aria-label": "Expand row"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: expanded ? 'angle-up' : 'angle-down'
  }));
}

getExpandableCell.displayName = "getExpandableCell";

var SortableTable = /*#__PURE__*/function (_React$Component) {
  _inherits(SortableTable, _React$Component);

  var _super = _createSuper(SortableTable);

  function SortableTable() {
    _classCallCheck(this, SortableTable);

    return _super.apply(this, arguments);
  }

  _createClass(SortableTable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          columns = _this$props.columns,
          header = _this$props.header,
          footer = _this$props.footer,
          rowClassName = _this$props.rowClassName,
          rowOnClick = _this$props.rowOnClick,
          rows = _this$props.rows,
          style = _this$props.style,
          truncate = _this$props.truncate,
          allSelected = _this$props.allSelected,
          onSelect = _this$props.onSelect,
          onSelectAll = _this$props.onSelectAll,
          rowSelected = _this$props.rowSelected,
          expandableColumn = _this$props.expandableColumn,
          onExpand = _this$props.onExpand,
          rowExpanded = _this$props.rowExpanded,
          renderRow = _this$props.renderRow,
          props = _objectWithoutProperties(_this$props, _excluded);

      var selectable = rowSelected;
      var expandable = onExpand;
      var showColgroup = selectable || expandable || columns.some(function (column) {
        return column.width;
      });
      var showFooter = columns.some(function (column) {
        return column.footer;
      });

      var tableStyle = _objectSpread({
        tableLayout: truncate ? 'fixed' : 'auto'
      }, style);

      var cols = _toConsumableArray(columns);

      if (selectable) {
        var selectAllId = uniqueId('select-all-');
        cols.unshift({
          align: 'center',
          key: 'select',
          header: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
            for: selectAllId,
            hidden: true
          }, "Select all rows"), /*#__PURE__*/React.createElement("input", {
            type: "checkbox",
            className: "mx-1",
            id: selectAllId,
            checked: allSelected,
            onClick: function onClick(e) {
              return e.stopPropagation();
            },
            onChange: function onChange(e) {
              return onSelectAll(e.target.checked);
            }
          })),
          cell: function cell(row) {
            return getSelectableCell(row, rowSelected, onSelect);
          },
          width: '2rem'
        });
      }

      if (expandable) {
        cols.push(_objectSpread({
          align: 'center',
          key: 'expand',
          cell: function cell(row, expanded) {
            return getExpandableCell(row, expanded, onExpand);
          },
          width: '2rem'
        }, expandableColumn));
      }

      return /*#__PURE__*/React.createElement(Table, _extends({
        style: tableStyle
      }, props), showColgroup && /*#__PURE__*/React.createElement("colgroup", null, cols.map(function (column) {
        return /*#__PURE__*/React.createElement("col", {
          key: column.key,
          style: {
            width: column.width
          }
        });
      })), /*#__PURE__*/React.createElement("thead", null, header, /*#__PURE__*/React.createElement("tr", null, cols.map(function (column) {
        return /*#__PURE__*/React.createElement(Header, {
          active: column.active,
          ascending: column.ascending,
          className: generateColumnClassName(column, truncate),
          key: column.key,
          onSort: column.onSort ? function () {
            return column.onSort(!column.ascending);
          } : null
        }, column.header);
      }))), /*#__PURE__*/React.createElement("tbody", null, rows.map(function (row, index) {
        var isLastRow = index === rows.length - 1;
        return renderRow(row, cols, rowClassName, rowExpanded, rowOnClick, truncate, rowSelected, isLastRow);
      })), (showFooter || footer) && /*#__PURE__*/React.createElement("tfoot", null, showFooter && /*#__PURE__*/React.createElement("tr", null, cols.map(function (column) {
        return /*#__PURE__*/React.createElement("td", {
          key: column.key,
          className: generateColumnClassName(column, truncate)
        }, column.footer);
      })), footer));
    }
  }]);

  return SortableTable;
}(React.Component);

_defineProperty(SortableTable, "propTypes", _objectSpread(_objectSpread({}, Table.propTypes), {}, {
  columns: PropTypes.arrayOf(PropTypes.shape({
    align: PropTypes.oneOf(['left', 'center', 'right']),
    active: PropTypes.bool,
    ascending: PropTypes.bool,
    cell: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    footer: PropTypes.node,
    header: PropTypes.node,
    key: PropTypes.string,
    onSort: PropTypes.func,
    width: PropTypes.string
  })).isRequired,
  rows: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) // ensure each row has a unique key

  })), PropTypes.object]),
  expandableColumn: PropTypes.object,
  header: PropTypes.node,
  footer: PropTypes.node,
  rowClassName: PropTypes.func,
  onExpand: PropTypes.func,
  onSelect: PropTypes.func,
  onSelectAll: PropTypes.func,
  rowExpanded: PropTypes.func,
  rowSelected: PropTypes.func,
  rowOnClick: PropTypes.func,
  allSelected: PropTypes.bool,
  truncate: PropTypes.bool,
  renderRow: PropTypes.func // TODO? support sort type icons (FontAwesome has numeric, A->Z, Z->A)

}));

_defineProperty(SortableTable, "defaultProps", _objectSpread(_objectSpread({}, Table.defaultProps), {}, {
  expandableColumn: {},
  rows: [],
  rowClassName: function rowClassName() {
    return undefined;
  },
  rowExpanded: function rowExpanded() {
    return false;
  },
  truncate: false,
  renderRow: defaultRenderRow
}));

SortableTable.displayName = "SortableTable";
export default SortableTable;